export default __webpack_public_path__ + "static/media/DesktopGifItem3.b1040cd5.gif";